import { stripHtml } from "string-strip-html";
import { Verbatims, LsChartData, LinescoreTabData, DriverTabData } from "../../models";
import { ReportsDataAction, LOAD_VERBATIMS, LOAD_VERBATIMS_FAIL, LOAD_VERBATIMS_SUCCESS, LOAD_BRANDS_DATA, LOAD_BRANDS_DATA_FAIL, LOAD_BRANDS_DATA_SUCCESS, LOAD_LINESCORE, LOAD_LINESCORE_FAIL, LOAD_LINESCORE_SUCCESS, LOAD_OTHER, LOAD_OTHER_FAIL, LOAD_OTHER_SUCCESS, LOAD_DRIVER, LOAD_DRIVER_FAIL, LOAD_DRIVER_SUCCESS, LOAD_RATINGS, LOAD_RATINGS_FAIL, LOAD_RATINGS_SUCCESS, CLEAR_DATA, LoadLinescoreSuccess, LoadLinescoresSuccess, LOAD_LINESCORES_SUCCESS, LOAD_CELL, CELL_LOADED, LOAD_CELL_FAIL } from "../actions";
import {  formatTable } from 'core';
import { LsTable, Cell } from 'core-lib';

function formatChart(data: LsChartData) {
    return {
        ...data,
        series: data.series.map(series => series.map(value => {
            // return Math.floor(value);
            const floored = Math.floor(value);
            if (floored === 0) {
                return null;
            } else
                return floored;
        }))
    };
}

interface EntityState<T> {
    loading: boolean;
    loaded: boolean;
    entity: T;
    ids: { label: string, id: string }[];
    entities: { [id: string]: any };
}

export interface ReportDataState {
    linescore: EntityState<LinescoreTabData>;
    brands: EntityState<any>;
    verbatims: EntityState<Verbatims>;
    other: EntityState<any>;
    driver: {
        loaded: boolean,
        loading: boolean,
        entities: any,
        items: DriverTabData[],
    };
    ratings: EntityState<any>;
    cell: EntityState<Cell>
    // linescores: EntityState<LinescoreTabData>;
}

export const initReportDataState: ReportDataState = {
    linescore: {
        loading: false, loaded: false, entity: null, ids: [], entities: {}
    },
    brands: {
        loading: false, loaded: false, entity: null, ids: [], entities: {}
    },
    verbatims: {
        loaded: false, loading: false, entity: null, ids: [], entities: {}
    },
    other: {
        loaded: false, loading: false, entity: null, ids: [], entities: {}
    },
    driver: {
        loaded: false, loading: false, items: [], entities: {}
    },
    ratings: {
        loaded: false, loading: false, entity: null, ids: [], entities: {}
    },
    cell: { loaded: false, loading: false, entity: null, entities: {}, ids: [] }
    // linescores: {
    //     loaded: false, loading: false, entity: null, ids: [], entities: {}
    // }
}

export function reportsDataReducer(state: ReportDataState = initReportDataState, action: ReportsDataAction): ReportDataState {
    switch (action.type) {
        case CLEAR_DATA: {
            return initReportDataState;
        }

        case LOAD_CELL: {
            return { ...state, cell: { ...state.cell, loading: true, loaded: false } }
        }

        case CELL_LOADED: {
            return {
                ...state,
                cell: { ...state.cell, loading: false, loaded: true, entity: action.payload }
            }
        }

        case LOAD_CELL_FAIL: {
            return {
                ...state,
                cell: { ...state.cell, loaded: false, loading: false, entity: null }
            }
        }

        case LOAD_RATINGS: {
            return {
                ...state,
                ratings: {
                    loaded: false, loading: true, entity: null, ids: [], entities: {}
                }
            }
        }

        case LOAD_RATINGS_FAIL: {
            return {
                ...state,
                ratings: {
                    loaded: false, loading: false, entity: null, ids: [], entities: {}
                }
            }
        }

        case LOAD_RATINGS_SUCCESS: {
            // console.log(action.payload);
            const ids: { id: string, label: string }[] = [],
                entities = {};
            const entity = action.payload.map(processRset);
            entity.forEach(({ rs_linescale, rs_avg_barchart, summary, rs_ranked }) => {
                ids.push({
                    id: rs_linescale.rsid,
                    label: rs_linescale.title
                }, {
                    id: summary.id,
                    label: summary.caption
                });
                // FIXME: Temp fix
                if (rs_avg_barchart) {
                    ids.push({
                        id: rs_avg_barchart.id,
                        label: rs_avg_barchart.title
                    });
                    entities[rs_avg_barchart.id] = rs_avg_barchart;
                }
                entities[rs_linescale.rsid] = rs_linescale;
                entities[summary.id] = summary;
            });
            return {
                ...state,
                ratings: {
                    loaded: true, loading: false, entity, ids, entities
                }
            };
        }

        case LOAD_DRIVER: {
            return {
                ...state, driver: {
                    loaded: false, loading: true, entities: {}, items: []
                }
            }
        }

        case LOAD_DRIVER_FAIL: {
            return {
                ...state, driver: {
                    loaded: false, loading: false, entities: {}, items: []
                }
            }
        }

            // function formatChart(data: LsChartData) {
            //     return {
            //         ...data,
            //         series: data.series.map(series => series.map(value => {
            //             // return Math.floor(value);
            //             const floored = Math.floor(value);
            //             if (floored === 0) {
            //                 return null;
            //             } else
            //                 return floored;
            //         }))
            //     };
            // }

        case LOAD_DRIVER_SUCCESS: {
            return {
                ...state, driver: {
                    loaded: true, loading: false,
                    items: action.payload.map(({ reasons_table, chart_AB, chart_AE, chart_AR, concept_label }) => ({
                        reasons_table: formatTable(reasons_table),
                        chart_AB: formatChart(chart_AB),
                        chart_AE: formatChart(chart_AE),
                        chart_AR: formatChart(chart_AR),
                        concept_label
                    })),
                    entities: {}
                }
            }
        }

        case LOAD_VERBATIMS: {
            return {
                ...state,
                verbatims: {
                    ...state.verbatims, loaded: false, loading: true,
                    ids: []
                },
            }
        }

        case LOAD_VERBATIMS_FAIL: {
            return {
                ...state, verbatims: {
                    ...state.verbatims, loaded: false, loading: false
                }
            }
        }

        case LOAD_VERBATIMS_SUCCESS: {
            return {
                ...state, verbatims: {
                    ...state.verbatims, loaded: true, loading: false,
                    entity: action.payload
                }
            }
        }

        case LOAD_BRANDS_DATA: {
            return {
                ...state, brands: {
                    ...state.brands, loaded: false, loading: true
                }
            }
        }

        case LOAD_BRANDS_DATA_FAIL: {
            return {
                ...state, brands: {
                    ...state.brands, loaded: false, loading: false
                }
            }
        }

        case LOAD_BRANDS_DATA_SUCCESS: {
            const table = formatTable(action.payload.control_1_table);
            const linescale = action.payload.competitors_linescale;
            const chart = action.payload.chart_frequencies;
            const entities = {};

            const ids = [{
                id: table.id, label: table.caption
            }, {
                id: 'chart_frequencies', label: chart.title
            }, {
                id: linescale.rsid,
                label: linescale.title
            }];
            entities[table.id] = table;
            entities[linescale.rsid] = linescale;
            entities[chart.id] = chart;

            // const averageChart = action.payload.chart_average_ratings;
            return {
                ...state, brands: {
                    ...state.brands, loaded: true, loading: false,
                    entity: {
                        ...action.payload,
                        control_1_table: table,
                        competitors_linescale: linescaleTransform(linescale)
                    },
                    ids, entities
                }
            }
        }

        case LOAD_LINESCORE: {
            return {
                ...state, linescore: {
                    ...state.linescore, loaded: false, loading: true
                }
            }
        }

        case LOAD_LINESCORE_FAIL: {
            return {
                ...state, linescore: {
                    ...state.linescore, loaded: false, loading: false
                }
            }
        }

        case LOAD_LINESCORE_SUCCESS: {
            return linescoreHandler(action, state);
        }

        case LOAD_OTHER: {
            return {
                ...state, other: {
                    ...state.other, loaded: false, loading: true
                }
            }
        }

        case LOAD_OTHER_FAIL: {
            return {
                ...state, other: {
                    ...state.other, loaded: false, loading: false
                }
            }
        }

        case LOAD_OTHER_SUCCESS: {
            const ids = [], entities = {};
            
            let strippedData = JSON.stringify(action.payload).replace(/<\$/g, '< ');
            strippedData = stripHtml(strippedData).result;
            
            const data = JSON.parse(strippedData);

            return {
                ...state, other: {
                    ...state.other, loaded: true, loading: false,
                    entity: data.map(item => {
                        switch (item.type) {
                            case 'vwchart': {
                                return {
                                    ...item,
                                    data: item.series.map(line => line.data),
                                    categories: item.categories,
                                    title: item.title,
                                    legend: item.legend
                                }
                            }

                            case 'table': {
                                ids.push({ id: item.id, label: item.caption });
                                entities[item.id] = item;
                                return item;
                            }
                        }

                        return item;
                    }),
                    ids, entities
                }
            };
        }

        case LOAD_LINESCORES_SUCCESS: {
            console.log('Hi');

            return linescoreHandler(action, state);
        }

    }

    return state;
}

function linescoreHandler(action: LoadLinescoreSuccess | LoadLinescoresSuccess, state: ReportDataState): ReportDataState {
    const diagnostics = action.payload.diagnostics;
    const tables: LsTable[] = action.payload.tables;
    const ids: { id: string, label: string }[] = [], entities = {};

    const diags = diagnostics.map(diag => {
        const linescale = diag.linescale;
        const diagTable = JSON.parse(JSON.stringify(formatTable(diag.table)).replace('<br>', ' '));

        // Set ids for nav frags
        ids.push({
            id: linescale.id,
            label: linescale.title
        }, {
            id: diagTable.id,
            label: diagTable.caption
        });
        entities[diagTable.id] = diagTable;
        entities[linescale.id] = linescale;

        const chunks: string[] = linescale.scale_text
            .map(textItem => textItem.split('<br>'))
            .filter(item => item.length)
            .reduce((labels, lines) => [
                ...labels,
                lines.join(' ')
            ], []);
        return {
            ...diag,
            table: diagTable,
            linescale: {
                ...linescale,
                title: stripHtml(linescale.title),
                scale_text: chunks,
                items: []
            }
        }
    });

    return {
        ...state, linescore: {
            ...state.linescore, loaded: true, loading: false,
            entity: {
                ...action.payload,
                diagnostics: diags,
                tables: tables.map(table => {
                    if (table.type === 'table') {
                        const cleanTable = formatTable(table);
                        ids.push({ id: table.id, label: table.caption });
                        entities[table.id] = cleanTable;
                        return cleanTable;
                    } else if (table.type === 'markup') {
                        return table;
                    }
                }),
                ...(action.payload.standard_competitors && {
                    competitors_table: formatTable(action.payload.standard_competitors.table),
                    competitors_linescale: action.payload.standard_competitors.competitors_linescale
                }),
                ...(action.payload.standard_competitors?.competitors_linescale ? {
                    competitors_linescale: linescaleTransform(action.payload.standard_competitors.competitors_linescale)
                } : { competitors_linescale: null })
            },
            ids, entities
        }
    }
}

export const loadedStatuses = (state: ReportDataState) => ({ linescore: state.linescore.loaded, brands: state.brands.loaded, verbatims: state.verbatims.loaded, driver: state.driver.loaded, other: state.other.loaded });

export const loadingStatuses = (state: ReportDataState) => ({ linescore: state.linescore.loading, brands: state.brands.loading, verbatims: state.verbatims.loading, driver: state.driver.loading, other: state.other.loading });

export const linescoreLoaded = (state: ReportDataState) => state.linescore.loaded;
export const linescoreLoading = (state: ReportDataState) => state.linescore.loading;
export const linescoreEntity = (state: ReportDataState) => state.linescore.entity;

export const brandsLoaded = (state: ReportDataState) => state.brands.loaded;
export const brandsLoading = (state: ReportDataState) => state.brands.loading;
export const brandsEntity = (state: ReportDataState) => state.brands.entity;

export const verbatimsLoaded = (state: ReportDataState) => state.verbatims.loaded;
export const verbatimsLoading = (state: ReportDataState) => state.verbatims.loading;
export const verbatimsEntity = (state: ReportDataState) => state.verbatims.entity;

export const otherLoaded = (state: ReportDataState) => state.other.loaded;
export const otherLoading = (state: ReportDataState) => state.other.loading;
export const otherEntity = (state: ReportDataState) => state.other.entity;

export const driverLoaded = (state: ReportDataState) => state.driver.loaded;
export const driverLoading = (state: ReportDataState) => state.driver.loading;
// export const driverEntity = (state: ReportDataState) => state.driver.entity;
export const driverItems = (state: ReportDataState) => state.driver.items;

export const ratingsLoaded = (state: ReportDataState) => state.ratings.loaded;
export const ratingsLoading = (state: ReportDataState) => state.ratings.loading;
export const ratingsEntity = (state: ReportDataState) => state.ratings.entity;

// export const linescores = (state: ReportDataState) => state.linescores.entity
// export const linescoresLoaded = (state: ReportDataState) => state.linescores.loaded
// export const linescoresLoading = (state: ReportDataState) => state.linescores.loading

export const cellLoaded = (state: ReportDataState) => state.cell.loaded;
export const cellLoading = (state: ReportDataState) => state.cell.loading;
export const cell = (state: ReportDataState) => state.cell.entity;

function linescaleTransform(linescale) {
    return {
        ...linescale,
        scale_text: linescale.data.scale_text.map((label: string) => {
            return label.replace('<br>', ' ');
        }),
        items: (linescale.data.varnames.map(key => {
            const ls = linescale.data[key];
            return {
                ...ls,
                value: ls.value / ls.counts,
                id: key,
                // Fix API to make this a boolean
                is_anchor: !!ls.highlight
            };
        }) as Array<any>).sort((a, b) => {
            return a.value - b.value;
        })
    }
}

export function processRset(item: any) {

    const { rs_linescale: linescale, rs_avg_barchart, rs_tabulation, rs_win_lose, rs_ranked, rs_checkbox } = item;
    // FIXME: Fix me
    const rsAvgChartSeries = rs_avg_barchart ? rs_avg_barchart.series[0].map(val => Math.floor(val)) : null;
    // console.log(rsAvgChartSeries);

    return {
        ...item,
        // rs_ranked: formatTable(rs_ranked),
        rs_checkbox: rs_checkbox ? formatTable(rs_checkbox) : null,
        rs_tabulation: rs_tabulation.map(table => formatTable(table)),
        rs_linescale: {
            ...linescale,
            scale_text: linescale.data.scale_text.map((label: string) => {
                return label.replace('<br>', ' ').trim();
            }),
            items: linescale.data.varnames.map(key => {
                const tmp = linescale.data[key];
                return {
                    label: tmp.label,
                    value: tmp.value / tmp.counts,
                    id: key,
                    is_anchor: !!tmp.highlight
                };
            }).sort((a, b) => a.value - b.value)
        },
        // rs_tabulation: rs_tabulation.map(table => formatTable(table)),
        rs_avg_barchart: rs_avg_barchart ? {
            ...rs_avg_barchart,
            categories: rs_avg_barchart.categories.map(cat => cat.label),
            min: (Math.abs(Math.min(...rsAvgChartSeries)) + 10) * -1,
            series: [
                rsAvgChartSeries
                // rs_avg_barchart.series[1].map(val => Math.floor(val))
            ]
        } : null,
        rs_win_lose: rs_win_lose.tables.map(table => {
            // TODO: Re-enable this later for exporting
            // ids.push({ id: table.win_table.id, label: table.win_table.caption })
            return formatTable(table.win_table);
        }),
        // TODO: Change API to use "summary" prop universally
        // FIXME: Property missing for archived reports
        summary: formatTable(item[`summary_${item.id}`])
    }
}